import * as types from './actionTypes'

export const fetchScheduler = (id) => ({
    type: types.SCHEDULER_FETCH,
    id
})

export const fetchSchedulerSuccess = (scheduler) => ({
    type: types.SCHEDULER_FETCH_SUCCESS,
    scheduler
})

export const fetchSchedulerFailed = () => ({
    type: types.SCHEDULER_FETCH_FAILED
})

export const fetchSchedulerData = (id) => ({
    type: types.SCHEDULER_DATA_FETCH,
    id
})

export const fetchSchedulerDataSuccess = (data) => ({
    type: types.SCHEDULER_DATA_FETCH_SUCCESS,
    data
})

export const fetchSchedulerDataFailed = () => ({
    type: types.SCHEDULER_DATA_FETCH_FAILED
})

export const updateScheduler = (config) => ({
    type: types.UPDATE_SCHEDULER,
    config
})

export const updateSchedulerSuccess = (scheduler) => ({
    type: types.UPDATE_SCHEDULER_SUCCESS,
    scheduler
})

export const updateSchedulerFailed = () => ({
    type: types.UPDATE_SCHEDULER_FAILED
})

export const setSchedulerColors = (id, data) => ({
    type: types.SET_SCHEDULER_COLORS,
    id,
    data
})

export const setSchedulerColorsSuccess = (scheduler) => ({
    type: types.SET_SCHEDULER_COLORS_SUCCESS,
    scheduler
})

export const setSchedulerColorsFailed = () => ({
    type: types.SET_SCHEDULER_COLORS_FAILED
})

export const deleteScheduler = (id) => ({
    type: types.SCHEDULER_DELETE,
    id
})

export const deleteSchedulerSuccess = (scheduler) => ({
    type: types.SCHEDULER_DELETE_SUCCESS,
    scheduler
})

export const deleteSchedulerFailed = () => ({
    type: types.SCHEDULER_DELETE_FAILED
})

export const resetScheduler = () => ({
    type: types.SCHEDULER_RESET
})

export const changeSchedulerEvent = (entity, record, planning, action) => ({
    type: types.SCHEDULER_EVENT_CHANGE,
    entity,
    record,
    planning,
    action
})

export const changeSchedulerEventSuccess = (data) => ({
    type: types.SCHEDULER_EVENT_CHANGE_SUCCESS,
    data
})

export const changeSchedulerEventFailed = () => ({
    type: types.SCHEDULER_EVENT_CHANGE_FAILED
})